import { colors, font } from '@chegg-ui/theme'
import styled from 'styled-components'

export const ProjectItemsMenu = styled.div`
  display: flex;
  padding-left: 20px;
  flex: 1;
  width: 100%;
  align-items: center;
  height: 66px;
  background-color: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => `1px solid ${theme.colors.grey}`};
`

export const ProjectItemsLeft = styled.div`
  display: flex;
  padding: 0 10px;
  margin-right: 10px;
  align-items: center;
`

export const SelectedText = styled.div`
  display: flex;
  padding: 0 10px;
  color: ${({ theme }) => theme.colors.orange};
  font-size: ${font.size.px20};
  font-weight: ${font.weight.bold};
`

export const SelectAll = styled.div`
  display: flex;
  padding: 0 20px 0 10px;
  color: ${colors.link};
  font-size: ${font.size.px18};
  cursor: pointer;
`
